import { useMemo } from 'react';

type TableRow = { id: string | number; [key: string]: unknown };

const SEARCH_KEYS = [
  'firstname',
  'lastname',
  'email',
  'function',
  'latestActivity',
  'type',
  'state',
] as const;

interface UseUserManagementParams {
  users: TableRow[];
  searchTerm: string;
  showGAShield?: boolean;
}

const useUserManagement = ({ users, searchTerm, showGAShield }: UseUserManagementParams) => {
  const filteredRows = useMemo(() => {
    let result = users;

    if (showGAShield) {
      result = result.filter(user => user['isGAShieldUser'] === true);
    }

    const term = searchTerm.trim().toLowerCase();
    if (term) {
      result = result.filter(user =>
        SEARCH_KEYS.some(key => {
          const val = user[key];
          return val != null && String(val).toLowerCase().includes(term);
        })
      );
    }

    return result;
  }, [users, searchTerm, showGAShield]);

  return {
    rows: filteredRows,
    totalCount: filteredRows.length,
  };
};

export default useUserManagement;